import React, { useEffect } from 'react'
import '../../scss/_login.scss'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import LoginForm from 'src/views/LoginComponents/LoginForm'
import SchoolSearchForm from 'src/views/LoginComponents/SchoolSearchForm'
import {
  getSchoolsSugestionFromSchoolCode,
  isAuthenticated,
  setCookieValues,
} from 'src/services/common-services'
import {
  getUserOtpConfiguration,
  userLoginOtpBased,
  userLoginPasswordBased,
} from 'src/services/auth/auth-services'
import AppLoader from 'src/components/AppLoader'
import Cookies from 'js-cookie'
import Swal from 'sweetalert2'
const UserLogin = () => {
  const navigate = useNavigate()
  const [loading, setloading] = useState(false)
  const [bgImage, setBgImage] = useState('../../src/assets/images/website/school.jpg')
  const [schoolCodeResults, setschoolCodeResults] = useState([])
  const [selectedSchoolDetails, setselectedSchoolDetails] = useState(null)
  const [loginFormValues, setloginFormValues] = useState({
    login_method: 'password_based',
    login_type: 'STAFF',
    loginid: '',
    password: '',
  })
  const [selectedMobileNumverForOtp, setselectedMobileNumverForOtp] = useState('')
  const [otpEnabledMobileNos, setotpEnabledMobileNos] = useState([])
  const [isOtpSent, setisOtpSent] = useState(false)
  const [enteredOtp, setenteredOtp] = useState('')
  const getSchoolsFromSchoolCode = async (value) => {
    getSchoolsSugestionFromSchoolCode(value)
      .then((result) => {
        setschoolCodeResults(result.data.school_array ?? [])
      })
      .catch((error) => {
        console.log(error)
      })
  }
  const performLogin = async () => {
    setloading(true)
    userLoginPasswordBased(
      loginFormValues.loginid,
      loginFormValues.password,
      selectedSchoolDetails.School_Code,
      loginFormValues.login_method,
      loginFormValues.login_type,
    )
      .then((response) => {
        if (response.data.status == 200) {
          const data = response.data.data
          const loginData = {
            schoolCode: selectedSchoolDetails.School_Code,
            School_Code: selectedSchoolDetails.School_Code,
            App_Type: selectedSchoolDetails.App_Type,
            School_Name: selectedSchoolDetails.School_Name,
            LOGINID: data.LOGINID,
            Login_Id: data.LOGINID,
            SCHOOLID: data.SCHOOLID,
            currentSession: data.SESSION,
            ROLEID: data.ROLEID,
            USERID: data.USERID,
            USERTYPE: data.USERTYPE,
            USERDESIGNATION: data.USERDESIGNATION,
            NAME: data.NAME,
            IMAGE: data.IMAGE,
            classSecId: data.SECTIONID ?? 0,
            classId: data.CLASSID ?? 0,
          }
          setCookieValues(loginData, 480)
          navigate('/')
        } else {
          alert(response.data.message)
        }
      })
      .catch((error) => {
        console.log('error ehile login', error)
      })
      .finally(() => {
        setloading(false)
      })
  }
  const checkOtpConfiguration = () => {
    const loginMethod = loginFormValues.login_method?.trim()
    const loginId = loginFormValues.loginid?.trim()
    if (loginMethod === 'otp_based' && loginId) {
      const otpConfigObject = {
        Client_Type: 'NOCHECK',
        fetch_mobile_numbers: 1,
        loginid: loginFormValues.loginid,
        login_type: loginFormValues.login_type,
        schoolCode: selectedSchoolDetails.School_Code,
        loginId: loginFormValues.loginid
      }
      getUserOtpConfiguration(otpConfigObject)
        .then((response) => {
          if (response.data.status != 200) {
            Swal.fire({
              text: response.data.message,
              icon: 'warning',
              timer: 2000,
            })
          } else {
            setotpEnabledMobileNos(response.data.data)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
  const sendOtp = () => {
    setloading(true)
    const otpConfigObject = {
      Client_Type: 'NOCHECK',
      send_sms: 1,
      recipient_no: selectedMobileNumverForOtp,
      Sms_Type: 'admission_enquiry',
      loginid: loginFormValues.loginid,
      login_type: loginFormValues.login_type,
    }
    getUserOtpConfiguration(otpConfigObject)
      .then((response) => {
        if (response.data.status != 200) {
          Swal.fire({
            text: response.data.message,
            icon: 'warning',
            timer: 2000,
          })
        } else {
          setisOtpSent(true)
          setenteredOtp("")
        }
      })
      .catch((error) => {
        console.log(error)
      }).finally(() => {
        setloading(false)
      })
  }
  const performOtpLogin = () => {
    const loginObject = {
      login_method: 'otp_based',
      login_type: loginFormValues.login_type,
      loginid: loginFormValues.loginid,
      password: '',
      mobile_no: selectedMobileNumverForOtp,
      votp: enteredOtp,
      recipient_no: selectedMobileNumverForOtp,
      redirect_url: '',
      schoolCode: selectedSchoolDetails.School_Code,
    }

    userLoginOtpBased(loginObject)
      .then((response) => {
        if (response.data.status == 200) {
          const data = response.data.data
          const loginData = {
            schoolCode: selectedSchoolDetails.School_Code,
            School_Code: selectedSchoolDetails.School_Code,
            App_Type: selectedSchoolDetails.App_Type,
            School_Name: selectedSchoolDetails.School_Name,
            LOGINID: data.LOGINID,
            Login_Id: data.LOGINID,
            SCHOOLID: data.SCHOOLID,
            currentSession: data.SESSION,
            ROLEID: data.ROLEID,
            USERID: data.USERID,
            USERTYPE: data.USERTYPE,
            USERDESIGNATION: data.USERDESIGNATION,
            NAME: data.NAME,
            IMAGE: data.IMAGE,
            classSecId: data.SECTIONID ?? 0,
            classId: data.CLASSID ?? 0,
          }
          setCookieValues(loginData, 480)
          navigate('/')
        }
      })
      .catch((error) => {
        console.log('error ehile login', error)
      })
      .finally(() => {
        setloading(false)
      })
  }
  useEffect(() => {
    const isUserAuthenticated = isAuthenticated()
    if (isUserAuthenticated) {
      navigate(-1)
      return
    }

    if (Cookies.get('schoolCode') && Cookies.get('App_Type') && Cookies.get('School_Name')) {
      const schoolData = {
        School_Code: Cookies.get('schoolCode'),
        App_Type: Cookies.get('App_Type'),
        School_Name: Cookies.get('School_Name'),
      }
      setselectedSchoolDetails({ ...schoolData })
    }
    if (Cookies.get('School_Name')) {
      document.title = Cookies.get('School_Name')
    } else {
      document.title = 'Swift Campus'
    }
  }, [])
  useEffect(() => {
    checkOtpConfiguration()
    setotpEnabledMobileNos([])
    setisOtpSent(false)
  }, [loginFormValues.login_method])

  return (
    <>
      <div className="school-bg-image login-bg">
        {!selectedSchoolDetails && (
          <SchoolSearchForm
            getSchoolsFromSchoolCode={getSchoolsFromSchoolCode}
            schoolCodeResults={schoolCodeResults}
            setselectedSchoolDetails={setselectedSchoolDetails}
          />
        )}
        {selectedSchoolDetails && (
          <LoginForm
            loginFormValues={loginFormValues}
            setloginFormValues={setloginFormValues}
            performLogin={performLogin}
            otpEnabledMobileNos={otpEnabledMobileNos}
            checkOtpConfiguration={checkOtpConfiguration}
            sendOtp={sendOtp}
            isOtpSent={isOtpSent}
            performOtpLogin={performOtpLogin}
            selectedMobileNumverForOtp={selectedMobileNumverForOtp}
            setselectedMobileNumverForOtp={setselectedMobileNumverForOtp}
            enteredOtp={enteredOtp}
            setenteredOtp={setenteredOtp}
          />
        )}
      </div>
      {loading && <AppLoader />}
    </>
  )
}

export default UserLogin
